import Results from "./Results";

class ResultsManager {

    private list: Results[] = [];
    private count: number;

    constructor() {
        this.count = 0;
    }

    public addResult(result: Results): void {
        if (this.count < 4) {
            this.list[this.count] = result;
            this.count++;
        }
    }

    public resetResults(): void {
        this.count = 0;
    }

    public getResults(): Results[] {
        return this.list.slice(0, this.count);
    }
}

export default ResultsManager;